import React from 'react';
import { render } from 'react-dom';
import { App } from './App';
import './index.css';
render(<App data-id="element-315" />, document.getElementById('root'));